import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { authStateSelector } from '../../store/selectors/userSelector'
import { useLocation } from 'react-router'

const Auth = (): JSX.Element => {
  const location = useLocation()
  const isAuthenticated = useSelector(authStateSelector)
  if (isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" replace />} />
      </Routes>
      <Outlet />
    </>
  )
}

export default Auth
